import React from 'react';
import { theme } from '../theme';
import { useBranding } from '../context/BrandingContext';
import ClientSelector from './ClientSelector';

const Navbar = ({ user, onLogout, pageTitle, maxWidth = '1400px', children }) => {
  const { branding } = useBranding();

  return (
    <nav style={{ ...styles.outerNav, backgroundColor: branding.colors.navbarBg || branding.colors.primary, color: branding.colors.navbarText || 'white' }}>
      <div style={{ ...styles.innerContainer, maxWidth: maxWidth }}>

        {/* LEFT: Branding */}
        <div style={styles.brandSection}>
          {/* 1. Logo (Optional) */}
          {branding.clientLogoUrl && (
            <img src={branding.clientLogoUrl} alt="Client Logo" style={styles.logoImg} />
          )}

          {/* 2. Client Name (static — always "RiverBid") */}
          <h1 style={styles.logoText}>{theme.branding.clientName}</h1>

          {/* 3. App Name (dynamic tenant portal name, falls back to the static app name) */}
          <span style={styles.appName}>{branding.portalName || theme.branding.appName}</span>

          {/* 4. Page Title (e.g. Admin Portal) - Only shows if passed prop exists */}
          {pageTitle && (
            <span style={styles.pageTitle}>{pageTitle}</span>
          )}
        </div>

        {/* CENTER: Navigation Tabs */}
        <div style={styles.linksSection}>
          {children}
        </div>

        {/* RIGHT: User Profile & Logout */}
        <div style={styles.userSection}>
          <ClientSelector user={user} />
          <span style={styles.welcome}>
            {user?.role === 'admin' || user?.role === 'superadmin' ? 'Admin: ' : 'Farmer: '} 
            <strong>{user?.name}</strong>
          </span>
          <button onClick={onLogout} style={styles.logoutBtn}>Logout</button>
        </div>

      </div>
    </nav>
  );
};

const styles = {
  outerNav: {
    width: '100%',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
  },
  innerContainer: {
    margin: '0 auto',
    height: '70px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 2rem',
    boxSizing: 'border-box'
  },
  brandSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px'
  },
  logoImg: {
    height: '40px',
    width: 'auto',
    backgroundColor: 'white',
    padding: '4px',
    borderRadius: '4px'
  },
  logoText: {
    margin: 0,
    fontSize: '1.4rem',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    whiteSpace: 'nowrap',
    lineHeight: '1'
  },
  appName: {
    fontSize: '1rem',
    opacity: 0.9,
    borderLeft: '1px solid rgba(255,255,255,0.4)', // First Separator
    paddingLeft: '15px',
    fontWeight: 'normal',
    whiteSpace: 'nowrap'
  },
  pageTitle: {
    fontSize: '1rem',
    opacity: 0.7,
    borderLeft: '1px solid rgba(255,255,255,0.4)', // Second Separator
    paddingLeft: '15px',
    fontWeight: '300',             // Thinner font to distinguish from App Name
    fontStyle: 'italic',            // Italic to show it's context, not brand
    whiteSpace: 'nowrap'
  },
  linksSection: {
    display: 'flex',
    gap: '20px',
    height: '100%',
    alignItems: 'center'
  },
  userSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px'
  },
  welcome: {
    fontSize: '0.95rem',
    whiteSpace: 'nowrap'
  },
  logoutBtn: {
    padding: '8px 16px',
    backgroundColor: 'rgba(255,255,255,0.15)',
    color: 'white',
    border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'all 0.2s',
    whiteSpace: 'nowrap'
  }
};

export const NavTab = ({ active, onClick, label, extraStyle = {} }) => (
  <button 
    onClick={onClick} 
    style={{
      background: 'none',
      border: 'none',
      color: active ? 'white' : 'rgba(255,255,255,0.7)',
      fontSize: '15px',
      cursor: 'pointer',
      padding: '22px 5px',
      fontWeight: 'bold',
      borderBottom: active ? '4px solid white' : '4px solid transparent',
      transition: 'color 0.2s',
      whiteSpace: 'nowrap',
      ...extraStyle
    }}
  >
    {label}
  </button>
);

export default Navbar;